import React from 'react'
import DatePicker from 'react-datepicker'
import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { FleetUtilizationExports } from './Exports'
import { canSelectRankingMachines } from '../../machinesranking/wizard/Model'
import { WizardData } from './Model'
import { getReportsFromDay } from '@/common/time'
import { ReportsFromDayNotice } from '@/components/reports/ReportsFromDayNotice'

export const FleetUtilizationWizardStep1 = () => {
  const { session, translates } = useAppContext()
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()
  const yesterday = new Date(new Date().setDate(new Date().getDate() - 1))
  // @ts-ignore react-datepicker exposes default differently in some builds
  const Picker = DatePicker.default ?? DatePicker
  if (!translates || !wizardData) return <div className='spinner'></div>
  return <div className='ranking-dates'><h3>{translates.for('report.fleetutilization.wizard.title')}</h3><ReportsFromDayNotice />
    <form className='main-form' onSubmit={e => { e.preventDefault(); nextStep() }}>
      <div className='form-field'><label htmlFor='fleet-from'>{translates.for('report.fleetutilization.wizard.from')}:</label>
        <Picker id='fleet-from' selected={wizardData.from} onChange={(value: Date | string) => updateWizardData({ ...wizardData, from: new Date(value) })} dateFormat='yyyy-MM-dd' minDate={getReportsFromDay() ?? undefined} maxDate={wizardData.to} className='border rounded p-2' portalId='tooltip-wrap' /></div>
      <div className='form-field'><label htmlFor='fleet-to'>{translates.for('report.fleetutilization.wizard.to')}:</label>
        <Picker id='fleet-to' selected={wizardData.to} onChange={(value: Date | string) => updateWizardData({ ...wizardData, to: new Date(value) })} dateFormat='yyyy-MM-dd' minDate={wizardData.from} maxDate={yesterday} className='border rounded p-2' portalId='tooltip-wrap' /></div>
      {canSelectRankingMachines(session?.user.role) && <div className='form-field'>
        <label htmlFor='fleet-select-machines' className='ranking-selection-toggle'>
          <input id='fleet-select-machines' type='checkbox' checked={wizardData.selectMachines}
            aria-label={translates.for('report.machinesranking.selection.title')} aria-describedby='fleet-selection-toggle-hint'
            onChange={e => updateWizardData({ selectMachines: e.target.checked })} />
          <span><strong>{translates.for('report.machinesranking.selection.title')}</strong>
            <span id='fleet-selection-toggle-hint' className='ranking-selection-toggle-hint'>{translates.for('report.machinesranking.selection.optional_hint')}</span>
          </span>
        </label>
      </div>}
      <div className='right-btns'>
        <button className='btn btn-next' type='submit'>{translates.for('report.fleetutilization.wizard.next')}</button>
        {!wizardData.selectMachines && <FleetUtilizationExports />}
      </div>
    </form></div>
}
